import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ddcd6de0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ddcd6de0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcd6de0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddcd6de0')) {
      api.createRecord('ddcd6de0', component.options)
    } else {
      api.reload('ddcd6de0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ddcd6de0&scoped=true", function () {
      api.rerender('ddcd6de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/aRGenerationNew/VehicleReceivables/index.vue"
export default component.exports